import isEqual from 'lodash/isEqual';
import {
  CartSkuOption,
  getDefaultSkuFromSkuArray,
  calcCanAddSkuToCart,
  calcTranslatedSkuWarningMessages,
} from 'cart-core';
import t from 'rcm-i18n';
import React, { Component, ChangeEvent } from 'react';
import { QuantitySelect } from 'cart-ui';

interface Props {
  skuOptions: CartSkuOption[];
  onContinueShopping: () => void;
  onAddToCart: (opts: Array<{ skuNumber: string; qty: number }>) => void;
  showPriceExcludesVatTaxMessage: boolean;
  productIndex: string;
}

interface State {
  quantity: number;
  skuIndex: number;
}

export default class AddToCartQuantityAndSkuForm extends Component<
  Props,
  State
> {
  public state: State = this.getDefaultState(this.props.skuOptions);

  protected addToCart = () => {
    this.props.onAddToCart([
      {
        qty: this.state.quantity,
        skuNumber: this.props.skuOptions[this.state.skuIndex].skuNumber,
      },
    ]);
  };

  protected handleQuantityChange = (event: ChangeEvent<HTMLSelectElement>) => {
    this.setState({ quantity: +event.target.value });
  };

  protected handleSkuOptionChange = (event: ChangeEvent<HTMLSelectElement>) => {
    this.setState({ skuIndex: +event.target.value });
  };

  public componentWillReceiveProps(nextProps: Props) {
    if (!isEqual(nextProps.skuOptions, this.props.skuOptions)) {
      this.setState(this.getDefaultState(nextProps.skuOptions));
    }
  }

  protected getDefaultState(skus: CartSkuOption[]) {
    const defaultSku = getDefaultSkuFromSkuArray(skus);
    const defaultSkuIndex = skus.findIndex(
      (sku: CartSkuOption) => sku.skuNumber === defaultSku.skuNumber
    );
    return {
      quantity: 1,
      skuIndex: defaultSkuIndex !== -1 ? defaultSkuIndex : 0,
    };
  }

  public render() {
    const selectedSku = this.props.skuOptions[this.state.skuIndex];
    const canAddToCart = calcCanAddSkuToCart(selectedSku, this.state.quantity);
    const translatedSkuWarningMessages = calcTranslatedSkuWarningMessages(
      selectedSku,
      this.state.quantity,
    );
    return (
      <div>
        <form>
          <div className='addToCart quantitySelector'>
            <label htmlFor='quantity'>{t('Quantity')}</label>
            <QuantitySelect
              id='quantity'
              className='form-control'
              value={this.state.quantity}
              onChange={this.handleQuantityChange}
            />
          </div>
          <br />
          <div className='addToCart skuSelector'>
            <label htmlFor='sku'>{t('Option')}</label>
            <select
              id='sku'
              className='form-control'
              value={this.state.skuIndex}
              onChange={this.handleSkuOptionChange}
            >
              {this.props.skuOptions.map((skuOption, i) => (
                <option key={i} value={i}>
                  {skuOption.name} - {skuOption.formattedRetailPrice}
                </option>
              ))}
            </select>
            {this.props.showPriceExcludesVatTaxMessage && (
              <div className='AddToCartQuantityAndSkuForm-priceExcludesVatTaxMessage'>
                <br />
                {t('VAT is added at checkout.')}
              </div>
            )}
          </div>
        </form>
        <br />
        {translatedSkuWarningMessages.map((message, index) => (
          <div key={index} className='alert alert-warning'>
            {message}
          </div>
        ))}
        <div className='clearfix button-container'>
          <a
            className='pull-sm-left btn btn-default'
            onClick={this.props.onContinueShopping}
          >
            {t('Cancel')}
          </a>
          {canAddToCart && (
            <a
              id={`modal-add-to-cart-button-${this.props.productIndex}`}
              className='pull-sm-right btn btn-primary'
              onClick={this.addToCart}
            >
              {t('Add to Cart')}
            </a>
          )}
        </div>
      </div>
    );
  }
}
